import React, { useState, useEffect } from 'react';
import { LinkedInEmbed } from 'react-social-media-embed';

// import { getBlogPosts } from '../../../services/mockBlogApi'; // Importando nosso serviço mockado
import { Container, Header, Loading, PostGrid, PostWrapper } from './styles';
import { ILinkedInPost } from '~/interfaces/ILinkedInPost';
import api from '~/services/api';

// Reutilizamos a mesma interface
interface BlogPost {
  id: string;
  linkedinUrl: string;
  position: number;
}

const Blog: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Busca os posts do nosso serviço mockado
    api.get<ILinkedInPost[]>('api/linkedin-posts').then((response) => {
      setPosts(response.data);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return <Loading>Carregando posts do blog...</Loading>;
  }

  return (
    <Container>
      <Header>
        <h1>Nosso Blog</h1>
        <p>Acompanhe nossas últimas atualizações diretamente do LinkedIn.</p>
      </Header>

      <PostGrid>
        {posts.map((post) => (
          <PostWrapper key={post.id}>
            <LinkedInEmbed url={post.linkedinUrl} width="100%" />
          </PostWrapper>
        ))}
      </PostGrid>
    </Container>
  );
};

export default Blog;
